import React, { useEffect } from "react";
import QlikCard from "shared/components/QlikCard";
import QlikObject from "shared/components/QlikObject";

export default function AuctionsPage({ title, pageTitle, menuItemsStrings, ExportChartFootnote }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <QlikObject
              className="page-title"
              id="QCPjYtt"
              height="35px"
              showLoader={false}
            /> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="Bcps"
              height="35px"
              showLoader={false}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-center">
          <div className="col-12">
            {/* vizTable */}
            <QlikCard
              id="mXJEnBE"
              height="670px"
              showLoader={true}
              showExport={true}
              showHeader={true}
              onBeforeExportHandler={async ({ vis, exportType }) => {
                console.log(vis);
                if(exportType in { pdf: true, image: true} && vis)
                  await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
              }}
              onAfterExportHandler={async ({ vis, exportType }) => {
                console.log('Export type: ', exportType);
                if(exportType in { pdf: true, image: true})
                  vis.setOptions({ showTitles: false, footnote:"" });
              }}
              exportText = {menuItemsStrings.exportText}
              exportCompletedText = {menuItemsStrings.exportCompletedText}
              closeBtnText = {menuItemsStrings.closeBtnText}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="rtPGHE"
              height="0px"
              showLoader={false}
            />
          </div>
        </div>

      </div>
    </section>
  );
}
